/* Stillward buy-first layer (v13). Runs after stillward-v7.js. */
(() => {
  'use strict';
  const $ = (q, r = document) => r.querySelector(q);
  const $$ = (q, r = document) => [...r.querySelectorAll(q)];
  const root = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');

  function init() {
    const main = $('[data-sr-add-main]');
    const sticky = $('[data-sr-sticky]');

    // Gallery thumbnails sit on the first screen, so load them straight away.
    $$('.sr-gallery-thumbs img[loading="lazy"]').forEach(img => { img.loading = 'eager'; });

    // Sticky bar: show it whenever the main button is not on screen, including on first load.
    if (main && sticky && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('sb-has-sticky');
      new IntersectionObserver(entries => {
        sticky.classList.toggle('sb-on', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(main);
    }

    // Express checkout: sits under the main button and follows the selected finish.
    const express = $('[data-sb-express]');
    if (express && main) {
      main.insertAdjacentElement('afterend', express);
      express.hidden = false;
      const input = $('[data-sb-variant-input]', express);
      const sync = () => {
        const query = new URLSearchParams(location.search);
        const id = query.get('variant');
        if (id && input) input.value = id;
        // Express checkout buys one item, so hide it while the two-item travel set is selected.
        express.classList.toggle('sb-off', query.get('set') === 'travel');
      };
      document.addEventListener('click', () => window.setTimeout(sync, 0));
      document.addEventListener('change', () => window.setTimeout(sync, 0));
      sync();
    }

    // Home: finish choice for the espresso maker.
    const finishButtons = $$('[data-sb-finish]');
    function setFinish(name) {
      finishButtons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.sbFinish === name)));
      $$('[data-sb-finish-name]').forEach(el => { el.textContent = name; });
      const photo = $('[data-sb-hero-photo]');
      const chosen = finishButtons.find(b => b.dataset.sbFinish === name);
      if (photo && chosen && chosen.dataset.photo) {
        photo.src = chosen.dataset.photo;
        if (chosen.dataset.alt) photo.alt = chosen.dataset.alt;
      }
    }
    finishButtons.forEach(b => b.addEventListener('click', () => setFinish(b.dataset.sbFinish)));
    const makerVariant = () => {
      const chosen = finishButtons.find(b => b.getAttribute('aria-pressed') === 'true' && !b.disabled);
      return chosen ? chosen.dataset.variant : '';
    };

    // Quick add: adds straight to the bag and opens it.
    let adding = false;
    document.addEventListener('click', async event => {
      const button = event.target.closest('[data-sb-add]');
      if (!button || adding) return;
      event.preventDefault();
      const ids = button.dataset.sbAdd.split(',').map(id => (id === 'MAKER' ? makerVariant() : id)).filter(Boolean);
      const note = $('[data-sb-note]', button.closest('[data-sb-scope]') || document);
      if (note) note.hidden = true;
      if (!ids.length) return;
      adding = true;
      button.disabled = true;
      button.classList.add('is-busy');
      try {
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: ids.map(id => ({ id: Number(id), quantity: 1 })) })
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || problem.message || 'That could not be added. Please try again.');
        }
        const bag = $('[data-sr-open-cart]');
        if (bag) bag.click();
        else location.assign(root + 'cart');
      } catch (error) {
        if (note) {
          note.textContent = error.message;
          note.hidden = false;
        }
      } finally {
        adding = false;
        button.disabled = false;
        button.classList.remove('is-busy');
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
